import { styled } from 'src/stitches'
import { Content } from 'src/components/Content/Content'

export const Root = styled(Content, {

})
